<template>
  <div>
    <div class="empty-state" v-show="actions.length === 0">
      <i class="fa fa-clipboard-list fa-4x"></i>
      <span>{{ $t('rsvpDetails.activityLogs.emptyState') }}</span>
    </div>

    <div v-for="(log, i) in actions" :key="i" @click="log.collapsed = !log.collapsed" :class="['action', {'collapsed':log.collapsed}]" v-show="checkLogToShow(log)">
      <div class="minimize">
        <div :class="['icon-display', {'hide-icon': log.consumer && log.consumer.id === quickResUserId}]">
          <i class="fa fa-plus-circle" v-if="!log.collapsed"></i>
          <i class="fa fa-minus-circle" v-else></i>
        </div>
        <div class="action-display">
          <span>{{dateSplit(log.created).date}} {{dateSplit(log.created).time}}  <p v-html="displayAction(log)"></p></span>
        </div>
      </div>

      <transition name="slide-down">
        <div v-show="log.collapsed" class="action-item" :id="'log' + i">
          <div class="icon-display"></div>
          <div class="action-display">
           <span class="log-details" v-html="displayLog(log, i)"></span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import ApiRsvpAction from '@/modules/api/reservation-details/action'
import moment from 'moment'
import services from '@/modules/api/services'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'action-logs',
  props: ['rsvpId'],
  data () {
    return {
      loading:false,
      quickResUserId: CONFIG.quickResUserId,
      searchedCoords: []
    }
  },
  computed: {
    _rsvpId () { return this.$route.params.id },
    actions () { return this.$store.state.rsvpDetails.actionLogs },
    rsvpAction () { return this.$store.state.rsvpDetails.rsvpAction }
  },
  methods: {
    init () {
      let self = this
      self.loading = true
      self.$store.commit('rsvpDetails/resetActionLogs')
      self.$forceUpdate()
      ApiRsvpAction.getActionLogs(self, self._rsvpId, function (res) {
        self.$forceUpdate()
        self.loading = false
      })
    },
    dateSplit (data) {
      let date =  moment(data, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, true))
      return {
        date: date.format('MM/DD/YYYY'),
        time: date.format(featureToggle.timeFormat(this, true))
      }
    },
    checkLogToShow (data) {
      switch (data.action) {
        case "assign_success": return false
        case "cron_dispatch": return false
        default: return true
      }
    },
    displayAction (data) {
      switch (data.action) {
        //actions from system
        case "notify_cons_pickup": return '<b>System sent notification for pickup</b>'
        case "notify_cons_pickup_result": return '<b>System sent notification for pickup Info</b>'
        case "notify_dispatch": return '<b>System sent notification for dispatch</b>'

        //payment actions
        case "refund_fail":
        case "fee_fail":
        case "cancel_fail": return `<b>${data.details.message}</b>`
        case "refund_success": return '<b>Successfully refunded a transaction</b>'

        //consumer actions
        case "pay_fail": return '<b>Customer made a payment but failed</b>'
        case "consumer_cancel": return '<b>Customer cancelled the reservation</b>'
        case "consumer_release": return '<b>Customer released the driver</b>'
        case "cons_mark_rtg": return '<b>Customer marked the reservation ready to go</b>'
        case "consumer_convert": return '<b>Customer set this reservation to Open Credit</b>'

        //provider actions
        case "driver_accept": return '<b>Driver accepted the reservation</b>'
        case "driver_release": return '<b>Driver released the reservation</b>'
        case "driver_release_attempt": return '<b>Driver attempted to release the reservation</b>'
        case "driver_onboard": return '<b>Driver marked the passenger on-board</b>'
        case "driver_ontheway": return '<b>Driver has started the trip</b>'
        case "driver_arrived": return '<b>Driver has arrived at the pickup location</b>'
        case "driver_arrivestop": return '<b>Driver has arrived at the extra stop location</b>'
        case "driver_noshow": return '<b>Driver marked the reservation as no-show</b>'
        case "driver_noshow": return '<b>Driver marked the reservation as no-show</b>'
        case "driver_complete": return '<b>Driver marked the reservation as completed</b>'
        case "driver_complete_attempt": return '<b>Driver attempted to complete the reservation</b>'
        case "driver_reject": return '<b>Driver declined the reservation request</b>'
        case "reject_schedule": return '<b>Driver declined a schedule request</b>'
        case "asap_booking": return '<b>Driver accepted the ASAP request</b>'
        case "asap_accepted": return '<b>Driver accepted the ASAP request</b>'
        case "driver_onboard_attempt": return '<b>Driver attempted to marked the passenger on-board</b>'
        case "driver_onboard_error": return '<b>Error trying to mark onboard</b>'

        // mtech
        case "mtech_error": return '<b>Mtech Error</b>'

        // lyft
        case "lyft_quote": return '<b>Lyft Quote</b>'
        case "lyft_create": return '<b>Created a ride with Lyft</b>'
        case "lyft_status": return `<span>Lyft Status:</span> <b style="margin-left: 5px">${this.lyftStatus(data.details.status)}</b>`
        case "lyft_cancel": return '<span>Lyft:</span> <b> Sent cancellation request</b>'
        case "lyft_receipt_ready": return '<span>Lyft:</span> <b>Ride Ended</b>'
        case "lyft_cancel_fee_error": return '<span>Lyft:</span> <b>Issue while charging cancellation fee</b>'
        case "auth_leave_uncaptured": return '<b>Intentionally not capturing Auth Trx</b>'
        case "cancel_fee_no_card": return '<b>Cancellation fee uncharged</b>'
        case "lyft_no_cancel_fees": return '<b>No Lyft cancellation fee</b>'
        case "lyft_tip_ok": return '<b>Lyft Tip OK</b>'
        case "lyft_tip_err": return '<b>Lyft Tip Error</b>'
        case "lyft_error": return '<b>Lyft Error</b>'

        case "trx_fail": return '<b>Transaction Failed</b>'
        case "driver_payment_force_override": return '<b>Driver Payment Force Override</b>'
        case "driver_valid_check": return '<b>Driver Valid Check</b>'
        case "overwork_check_result": return '<b>Overwork Check Result</b>'
        case "overwork_check_skip": return '<b>Overwork Check Skip</b>'
        case "rating": return '<b>Rating</b>'

        //admin actions
        case "assign_attempt": return '<b>Admin assigned the reservation to the driver</b>'
        case "assign_success": return '<b>Reservation has been successfully assigned</b>'
        case "mark_complete": return '<b>Admin marked the reservation as completed</b>'
        case "mark_complete_attempt": return '<b>Admin tried to mark the reservation as complete</b>'
        case "sent_provider": return '<b>Admin sent the reservation to the driver</b>'
        case "sent_asap": return '<b>Admin sent the reservation as ASAP</b>'
        case "auto_dispatch": return '<b>Admin triggered auto dispatch</b>'
        case "move_pool": return '<b>Admin moved the reservation to the pool</b>'
        case "remove_pool": return '<b>Admin removed the reservation from the pool</b>'
        case "cancel_rsvp": return '<b>Admin cancelled the reservation</b>'
        case "refund": return '<b>Admin issued a full refund</b>'
        case "refund_partial": return '<b>Admin issued a partial refund</b>'
        case "remove_noshow_payout": return '<b>Admin removed the no-show payout</b>'
        case "issue_credit": return '<b>Admin issued additional credits to the customer</b>'
        case "add_charge": return '<b>Admin made additional charges to the customer</b>'
        case "admin_noshow": return '<b>Admin marked the reservation as no-show</b>'
        case "send_schedule": return '<b>Admin sent the reservation to a driver as part of a schedule</b>'
        case "admin_mark_rtg": return '<b>Admin marked the reservation ready to go</b>'
        case "release_driver": return '<b>Admin released the driver</b>'
        case "admin_convert": return '<b>Admin set this reservation to Open Credit</b>'
        case "run_assign_attempt": return '<b>Admin assigned the run to the driver</b>'
        case "run_assign_success": return '<b>Run has been successfully assigned</b>'
        case "run_sent_provider": 
          return data.admin ? '<b>Admin sent the run to the driver</b>' : '<b>System sent the run to the driver</b>'
        case "run_accepted": return '<b>Driver accepted the run</b>'
        case "run_declined": return '<b>Driver declined the run request</b>'
        case "optin_shared": return '<b>Reservation converted to a shared service.</b>'
        case "optin_exclusive": return '<b>Reservation converted to exclusive.</b>'
        case "static_mark_rtg": return '<b>Marked reservation as Ready To Go on a kiosk</b>'
        case "manual_rsvp_reminder": return '<b>Manually triggered trip reminder.</b>'
        case "run_create": return data.admin ? '<b>Admin created a run</b>' : '<b>System created a run</b>'

        case "edit_rsvp":
          if (data.admin) return '<b>Admin made an update</b>'
          return '<b>Customer made an update</b>'

        case "create_rsvp":
          if (data.admin) return '<b>Admin created the reservation</b>'
          return data.consumer && data.consumer.id === CONFIG.quickResUserId ? '<b>Driver created the reservation</b>' : '<b>Customer created the reservation</b>'

        case "update_fail":
          if (data.admin) return '<b>Admin made an update but failed</b>'
          return '<b>Customer made an update but failed</b>'

        case "refund_converted":
          if (data.admin) return '<b>Admin converted the reservation into ride credits</b>'
          return '<b>Customer converted the reservation into ride credits</b>'

        case "credit_reclaimed":
          if (data.admin) return '<b>Admin reclaimed the converted credits and refunded the charges</b>'
          return '<b>Customer reclaimed the converted credits and refunded the charges</b>'

        case "resend_email":
        case "resend_email_cons":
        case "resend_email_prov":
          let userType = 'Admin'
          if (!data.admin) {
            if (!data.provider) userType = 'Customer'
            else userType = 'Driver'
          }
          switch(data.details.email.template) {
            case "rsvp/admincancel":
            case "rsvp/canceled": return `<b>${userType} resent the cancellation email</b>`
            case "rsvp/confirmation":
            case "rsvp/roundtrip": return `<b>${userType} resent the confirmation email</b>`
            case "rsvp/completed": return `<b>${userType} resent the receipt email</b>`
            case "rsvp/refunded": return `<b>${userType} resent the refund email</b>`
          }
        default: return `<b>${data.action}</b>`
      }
    },
    displayLog (data, i) {
      let self = this
      let createdTime = self.dateSplit(data.created).date + ' ' + self.dateSplit(data.created).time
      let admin = data.admin ? '<br/><div>Admin ID: <b>'+ data.admin.id +
      '</b></div><div>Admin Name: <b>'+ data.admin.name +
      '</b></div> <div>Admin Email: <b>'+ data.admin.email +'</b></div>' : ''
      let provider = data.provider ? '<br/><div>Driver ID: <b><a href="/#/provider/'+data.provider.id+'" target="_blank">'+ data.provider.id +
      '</a></b></div><div>Driver Name: <b>'+ data.provider.name +
      '</b></div> <div>Driver Email: <b>'+ data.provider.email +'</b></div>' : ''
      let consumer = data.consumer ? '<br/><div>Customer ID: <b><a href="/#/consumer/'+data.consumer.id+'" target="_blank">'+ data.consumer.id +
      '</a></b></div><div>Customer Name: <b>'+ data.consumer.name +
      '</b></div> <div>Customer Email: <b>'+ data.consumer.email +'</b></div>' : ''
      if (data.consumer && data.consumer.id === CONFIG.quickResUserId) {
        consumer = ''
      }
      let recipient = data.recipient ? '<br/><div>Recipient ID: <b><a href="/#/provider/'+data.recipient.id+'" target="_blank">'+ data.recipient.id +
      '</a></b></div><div>Recipient Name: <b>'+ data.recipient.name +
      '</b></div> <div>Recipient Email: <b>'+ data.recipient.email +'</b></div>' : ''
      // let coordinates = data.details.coords ? `<div>Location: <i>lat: </i><b>${data.details.coords.lat} </b> <i>lng: </i><b>${data.details.coords.lng}</b><a href="https://www.google.com/maps/search/${data.details.coords.lat},${data.details.coords.lng}" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a></div>` : ''
      // let driverCoords = data.details.driverCoords ? `<div>Location: <i>lat: </i><b>${data.details.driverCoords.lat} </b> <i>lng: </i><b>${data.details.driverCoords.lng}</b><a href="https://www.google.com/maps/search/${data.details.driverCoords.lat},${data.details.driverCoords.lng}" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a></div>` : ''
      let coordinates = data.details.coords ? `<div class="coords">Location: <i class="fas fa-spinner fa-spin fa-fw slow-spin"></i><span></span></div>` : ''
      let driverCoords = data.details.driverCoords ? `<div class="coords">Location: <i class="fas fa-spinner fa-spin fa-fw slow-spin"></i><span></span></div>` : ''
      let amount = data.details.amount ? '<div>Amount: <b>$'+data.details.amount+'</b></div>' : ''
      let creditAmount = data.details.amount ? '<div>Amount: <b>-$'+ Math.abs(data.details.amount)+'</b></div>' : ''
      let ipAddress = data.details.ip ? '<div>IP Address: <b>'+data.details.ip+'</b></div>' : ''
      if (data.consumer && data.consumer.id === CONFIG.quickResUserId) {
        ipAddress = ''
      }
      let driverInfo = data.details.driverInfo ? '<br/><div>Driver ID: <b><a href="/#/provider/'+data.details.driverInfo.id+'" target="_blank">'+ data.details.driverInfo.id +
      '</a></b></div><div>Driver Name: <b>'+ data.details.driverInfo.name + '</b></div> <div>Driver Email: <b>'+ data.details.driverInfo.email +'</b></div>' : ''
      // let releaseNote = data.details.params.charge ? '<div>Admin chose to charge the driver</div>' : '<div>Admin chose to release the driver for free</div>'
      let fields = []

      let hasCoords = ['driver_accept', 'driver_ontheway', 'driver_onboard', 'driver_arrived', 'driver_arrivestop', 'driver_noshow', 'driver_complete', 'driver_reject', 'asap_booking', 'asap_accepted', 'reject_schedule', 'driver_release']
      if (hasCoords.indexOf(data.action) > -1 && data.collapsed && data) {
        self.coordsLookup(data.details.coords || data.details.driverCoords, i)
      }

      let runsLog = ['run_assign_attempt', 'run_assign_success', 'run_sent_provider', 'run_accepted', 'run_declined']
      let RSVPs = ''
      if (runsLog.indexOf(data.action) > -1) {
        provider = '<br/><div>Driver ID: <b><a href="/#/provider/'+data.details.driverID+'" target="_blank">'+ data.details.driverID +
          '</a></b></div><div>Driver Name: <b>'+ data.details.driverName +'</b></div>'
        RSVPs = '<br/><div>RSVPs within run: '
        let temp_rsvp = []
        data.details.rsvpIds.forEach(rsvp => {
          temp_rsvp.push(`<b><a href="/#/reservation/${rsvp}" target="_blank">${rsvp}</a></b>`)
        })
        RSVPs = RSVPs + temp_rsvp.join(', ')
      }
      if (data.action === 'run_create') {
        let temp_rsvp = []
        data.details.rsvpIds.forEach(rsvp => {
          temp_rsvp.push(`<b><a href="/#/reservation/${rsvp}" target="_blank">${rsvp}</a></b>`)
        })
        RSVPs = `
          <br/><div>RUN ID: <b>${data.details.runId}</b></div>
          <div>RSVPs within run: ${temp_rsvp.join(', ')}</div>
        `
      }

      switch (data.action) {
        default: return consumer
        case "edit_rsvp":
          data.fields.forEach((log) => {
            if (log.field === 'payment.cardID') { return }
            if (log.field === 'waive_payment') {
              fields.push(
                '<div style="background: #a51a1a;color: #fff;line-height: 1;padding: 3px 8px;border-radius: 3px;letter-spacing: .6px;border: 1px solid #600606;display:inline-block;margin-top:20px"><b>Waived Payment</b></div><br/>'
              )
            }
            if (self.checkField(log).show) {
              fields.push(
                '<br/><div><b>'+ self.labelFormat(log.field) +'</b></div><div>'+ self.valueFormat(log.field, log.old) +' <i class="fas fa-chevron-right"></i> <b>'+ self.valueFormat(log.field, log.new)+'</b></div>'
              )
            }

          })
          return !consumer.length ? admin + ipAddress + fields.join('') : consumer + ipAddress + fields.join('')

        case "create_rsvp": return !consumer.length ? admin + ipAddress : consumer + ipAddress

        case "refund_converted": return !consumer.length ? admin + ipAddress : consumer + ipAddress
        case "credit_reclaimed": return !consumer.length ? admin + creditAmount + ipAddress : consumer + creditAmount + ipAddress

        case "update_fail": return !consumer.length ? admin + '<div>Cause: <b>'+ data.details.message +'<b/></div>' : consumer + '<div>Cause: <b>'+ data.details.message +'<b/></div>'

        case "notify_cons_pickup_result": return `Email: <b>${data.details.email || ''}</b><div>SMS: <b>${data.details.sms}</b></div>`

        //payment
        case "refund_fail":
        case "fee_fail":
        case "cancel_fail": return data.details.error.message
        case "refund_success": return data.details.message

        //consumer
        case "pay_fail": return consumer
        case "cons_mark_rtg": return consumer
        case "consumer_cancel":
          return `${consumer}
            <div>Cancellation Fee: <b>$${data.details.cancellationFee}</b></div>
            <div>Cancellation Reason: <b>${data.details.cancellationReason}</b></div>
          `
        case "resend_email_cons": return consumer + '<div>Subject: <b>'+ data.details.email.subject +'</b></div> <div>Message: <b>'+ data.details.email.template +'</b></div>'
        case "consumer_release": return consumer + driverInfo
        case "consumer_convert":
          let consCancelReason = data.details.cancellationReason
          consCancelReason ? consCancelReason : consCancelReason = 'Unspecified'
          return `${consumer}
            <div>Cancellation Fee: <b>$0</b></div>
            <div>Cancellation Reason: <b>${consCancelReason}</b></div>
          `

        //driver
        case "driver_accept": return provider + coordinates
        case "driver_ontheway": return provider + coordinates
        case "driver_onboard": return provider + coordinates
        case "driver_arrived": return provider + driverCoords
        case "driver_arrivestop": return provider + driverCoords
        case "driver_noshow": return provider + coordinates
        case "driver_complete":
          let error = (data.details && data.details.error) ? `<i class="float-mt">${data.details.error}</i><br/>` : ''
          return `${error} ${provider} ${coordinates}`
        case "driver_complete_attempt":
          return (data.details && data.details.error) ? `<i class="float-mt">${data.details.error}</i>` : ''
        case "driver_reject": return provider + coordinates
        case "asap_booking": return provider + coordinates
        case "asap_accepted": return provider + driverCoords
        case "reject_schedule": return provider + coordinates
        case "driver_release": return provider + coordinates + '<div>Release Fee: <b>$'+ data.details.fee.Charge +'</b></div>'
        case "resend_email_prov": return provider + '<div>Subject: <b>'+ data.details.email.subject +'</b></div> <div>Message: <b>'+ data.details.email.template +'</b></div>'
        case "driver_onboard_error": return `<div>${data.details.err || ''}</div>`

        // mtech error
        case "mtech_error": return `<div>${data.details.error}</div>`

        // lyft
        case "auth_leave_uncaptured": return `<div>${data.details.message}</div>`
        case "cancel_fee_no_card": return `<div>${data.details.message}</div>`
        case "lyft_no_cancel_fees": return `<div>${data.details.message}</div>`
        case "lyft_tip_err": return `<div>${data.details.err || ''}</div>`
        case "lyft_error":
          let extraMsg = data.details.response ? JSON.parse(data.details.response) : ''
          if (extraMsg) extraMsg = extraMsg.error.error_description
          return `<div>${data.details.error + '.<br/>' || ''} ${extraMsg || ''}</div>`

        case "trx_fail": return `<div>${data.details.error.message}</div>`
        case "driver_payment_force_override": return `
          <div>Original Payment: <b>$${data.details.paidForProvider}</b></div>
          <div>Original Override: <b>$${data.details.overridePayment}</b></div>
          <div>New Override: <b>$${data.details.newValue}</b></div>
        `
        case "driver_valid_check": return `
          <div>Max Work mins: <b>${data.details.maxWorkMins}</b></div>
          <div style="padding-bottom: 7px">Violation Max Work: <b>${data.details.violateMaxWork}</b></div>
          <div>Min Rest mins: <b>${data.details.minRestMins}</b></div>
          <div>Violation Min Rest: <b>${data.details.violateMinRest}</b></div>
        `
        case "overwork_check_result": {
          let violateMaxWork = (data.details.violateMaxWork != null) ? `<div style="padding-bottom: 7px">Violation Max Work: <b>${data.details.violateMaxWork}</b></div>` : ''
          let violateMinRest = (data.details.violateMinRest != null) ? `<div style="padding-bottom: 7px">Violation Min Rest: <b>${data.details.violateMinRest}</b></div>` : ''
          return `
            <div>Max Work mins: <b>${data.details.maxWorkMins}</b></div>
            ${violateMaxWork}
            <div>Min Rest mins: <b>${data.details.minRestMins}</b></div>
            ${violateMinRest}
            <div>Trips: <b>${data.details.displayTrips}</b></div>
          `
        }
        case "overwork_check_skip": return data.details.displayMsg
        case "rating": return `
          <div>Rating: <b>${data.details.rating}</b></div>
          <div>Review: <b>${data.details.review}</b></div>
          <div>Tip: <b>$${data.details.tip}</b></div>
        `

        //admin
        case "assign_attempt": return admin + recipient
        case "assign_success": return admin + recipient
        case "sent_provider": return admin + recipient
        case "sent_asap": return admin + recipient
        case "auto_dispatch": return admin
        case "move_pool": return admin
        case "remove_pool": return admin
        case "admin_noshow": return admin
        case "admin_mark_rtg": return admin
        case "resend_email": return admin + '<div>Subject: <b>'+ data.details.email.subject +'</b></div> <div>Message: <b>'+ data.details.email.template +'</b></div>'
        case "mark_complete": 
          let note = ''
          if (data.details.error) note = data.details.error
          if (data.details.params && data.details.params.notes) note = data.details.params.notes
          return admin + '<div>Note: <b>'+ note +'</b></div>'
        case "mark_complete_attempt": 
          let note2 = ''
          if (data.details.error) note2 = data.details.error
          if (data.details.params && data.details.params.notes) note2 = data.details.params.notes
          return `${admin} ${note2 ? '<div>Note: <b>'+note2+'</b></div>' : ''}`
        case "cancel_rsvp": 
          return `${admin}
            <div>Cancellation Fee: <b>$${data.details.messaging.CancellationFee}</b></div>
            <div>Cancellation Reason: <b>${data.details.cancellationReason}</b></div>
            <div>Note: <b>${data.details.notes}</b></div>
          `
        case "release_driver": let releaseNote = data.opted ? '<br/><div>Admin opted to charge release fee from the driver</div>' : '<br/><div>Admin did not opt to charge release fee from the driver</div>'
        return admin + driverInfo + releaseNote
        case "refund": return admin + '<div>Cancel: <b>'+ data.details.cancel +'</b></div> <div>Charge Fee: <b>'+ data.details.chargeFees +'</b></div>'
        case "refund_partial": return admin + amount
        case "remove_noshow_payout": return admin + '<div style="margin-top:3px;letter-spacing: .5px">' + JSON.stringify(data.details) + '</div>'
        case "issue_credit": return admin + amount
        case "add_charge": return admin + amount
        case "send_schedule": return admin + recipient + '<div>Schedule ID: <b>'+ data.details.scheduleId +'</b></div> <div>RSVP ID: <b>'+ data.details.contents.rsvp +'</b></div> <div>Package ID: <b>'+ data.details.contents.pkg +'</b></div>'
        case "admin_convert":
          let adminCancelReason = data.details.cancellationReason
          adminCancelReason ? adminCancelReason : adminCancelReason = 'Unspecified'
          return admin + '<div>Cancellation Fee: <b>$0</b></div>' +
                '<div>Cancellation Reason: <b>' + adminCancelReason + '</b></div>' +
                '<div>Note: <b>'+ data.details.notes +'</b></div>'
        case "run_assign_attempt": return admin + provider + RSVPs
        case "run_assign_success": return admin + provider + RSVPs
        case "run_sent_provider": return admin + provider + RSVPs
        case "run_accepted": return admin + provider + RSVPs
        case "run_declined": return admin + provider + RSVPs
        case "run_create": return data.admin ? admin + RSVPs : RSVPs
      }
    },
    checkField (data) {
      let exception = [
        'pickup.address1', 'pickup.address2', 'pickup.lat', 'pickup.lng', 'pickup.geofenceId',
        'pickup.city', 'pickup.zip', 'pickup.state', 'pickup.country',
        'dropoff.address1', 'dropoff.address2', 'dropoff.lat', 'dropoff.lng', 'dropoff.geofenceId',
        'dropoff.city', 'dropoff.zip', 'dropoff.state', 'dropoff.country', 'ada.wheelchair', 'ada.serviceDog',
        'waive_payment'
      ]

      let show = !exception.includes(data.field)
      if (data.field === 'pickup.address2' &&
        ((data.old && data.old.indexOf('Apt/Gate') > -1) || (data.new && data.new.indexOf('Apt/Gate') > -1)) &&
        data.old !== data.new
      ) {
        show = true
      }
      return { show: show }
    },
    labelFormat (field) {
      switch (field) {
        default: return field.replace(/^\w/, c => c.toUpperCase())
        case 'pickup.title': return 'Pickup'
        case 'pickup.address2': return 'Apt/Gate'
        case 'dropoff.title': return 'Dropoff'
        case 'pickupTime': return 'Pickup Time'
        case 'passengers': return 'Passenger'
        case 'luggage': return 'Luggage'
        case 'overridePayment': return 'Driver Payment Override'
        case 'driverBonus': return 'Driver Payment Bonus'
        case 'overridePrice': return 'Price Override'
        case 'payment.tip': return 'Tip'
        case 'payment.promo': return 'Promo'
        case 'notes': return 'Note to Driver'
        case 'serviceTypeId': return 'Service'
        case 'amount': return 'Fare'
        case 'wheelChairLift': return 'Wheelchair'
        case 'serviceDog': return 'Service Dog'
        case 'payment.cardID': return 'Payment Card'
        case 'deviceType': return 'Device Used'
        case 'flightNumber': return 'Flight Number (Arrival)'
        case 'flightName': return 'Airline (Arrival)'
        case 'dropoffFlightNumber': return 'Flight Number (Departure)'
        case 'dropoffFlightName': return 'Airline (Departure)'
        case 'pickupType': return 'Pickup Type'
        case 'guestFname': return 'Guest First Name'
        case 'guestLname': return 'Guest Last Name'
        case 'guestPhone': return 'Guest Phone'
        case 'etaInSec': return 'Duration'
        case 'optinShared': return 'Opt-in Shared'
        case 'portalFee': return 'Portal Fee'
        case 'travelInsurance': return 'Rider Fee'
        case 'airportFee': return 'Airport Fee'
        case 'gasFee': return 'Gas Fee'
      }
    },
    valueFormat (field, value) {
      if (!value && field != 'optinShared') { return 'none' }
      if (['pickup.address2'].includes(field)) {
        return value.split('Apt/Gate: ')[1]
      }
      if (['pickupTime'].includes(field)) {
        return moment(value, 'YYYY-MM-DD ' + featureToggle.timeFormat(this, true)).format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }
      let dollarFields = [
        'amount', 'payment.tip', 'overridePrice', 
        'overridePayment', 'driverBonus', 'airportFee', 
        'travelInsurance', 'gasFee', 'portalFee'
      ]
      if (dollarFields.includes(field)) return '$' + parseFloat(value).toFixed(2)

      if (['serviceDog', 'wheelChairLift'].includes(field)) {
        return value ? 'Checked' : 'Unchecked'
      }
      if (['serviceTypeId'].includes(field)) {
        if (value > 5) {
          let service = services.getServiceData(this, value)
          return '<span class="__service-label" style="background:' + service.color + '">' + service.label + '</span>'
        }
        let label = ''
        switch (value) {
          case 1:
            label = 'shared'
            break
          case 2:
            label = 'opoli'
            break
          case 3:
            label = 'black'
            break
          case 4:
            label = 'suv'
            break
          case 5:
            label = 'shuttle'
            break
        }
        return '<span class="__service-label ' +label+ '">' + services.getServiceName(label) + '</span>'
      }
      if (field == 'optinShared') {
        return value == 1 ? 'Enabled' : 'Disabled'
      }
      return value
    },
    fieldClass (field) {
      if (['pickup.title', 'dropoff.title', 'notes'].includes(field)) {
        return 'no-arrow'
      }
      return ''
    },
    coordsLookup (data, i) {
      if (!data) return
      let self = this
      // if looked-up already -- just display previous return
      let searchedIndex = self.searchedCoords.findIndex(x => x.coords === `${data.lat},${data.lng}`)
      if (searchedIndex > -1) {
        document.querySelector(`#log${i} .action-display .fa-spinner`).style.display = "none"
        document.querySelector(`#log${i} .action-display .coords span`).innerHTML = self.searchedCoords[searchedIndex].addr
        return
      }
      // let url = 'https://discover.search.hereapi.com/v1/discover?at={AT}&q={SEARCH}&apiKey={API_KEY}'
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&apiKey={API_KEY}&show=tz'
      url = url.replace('{AT}', encodeURIComponent(data.lat + ',' + data.lng))
        .replace('{SEARCH}', 'location')
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        let location = ''
        if (err || !body.items || body.items.length === 0) { // eslint-disable-line no-undef
          location = `<i>lat: </i><b>${data.lat} </b> <i>lng: </i><b>${data.lng}</b><a href="https://www.google.com/maps/search/${data.lat},${data.lng}" target="_blank"><i class="fa fa-map-marker m-L-5"></i></a>`
        }
        if (body.items.length) {
          // location = `<b>${body.items[0].address.city}, ${body.items[0].address.stateCode || body.items[0].address.state} ${body.items[0].address.postalCode}</b>`
          location = `
            <b style="margin-right:4px;">${body.items[0].address.label}</b>
            <a href="https://www.google.com/maps/search/${data.lat},${data.lng}" target="_blank">
              <i class="fas fa-link"></i>
            </a>
          `
          self.searchedCoords.push({
            coords: `${data.lat},${data.lng}`,
            addr: location
          })
        }
        document.querySelector(`#log${i} .action-display .fa-spinner`).style.display = "none"
        document.querySelector(`#log${i} .action-display .coords span`).innerHTML = location
      })
    },
    lyftStatus (x) {
      if (!x) return ''
      if (x === 'pickedUp') return 'Picked Up'
      if (x === 'droppedOff') return 'Dropped Off'
      return x.charAt(0).toUpperCase() + x.slice(1)
    }
  },
  watch: {
    // rsvpId: function (value) {
    //   this.init()
    // },
    rsvpAction (value) {
      if(value.show) {
        this.init()
      }
    }
  },
  mounted () {
    // this.init()
  }
}
</script>

<style lang="scss" scoped>
.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}

.action{
  border: 1px solid #ddd;
  width: 100%;
  max-height:auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  transition: all .35s ease-in-out;
  cursor: pointer;
  margin-bottom: 10px;

  &:hover { background: #fff8dc; }

  &.collapsed{
    padding: 10px;
    background: #fff8dc;
    }
  .action-item {
    padding-left: 15px;
    transform-origin: top center;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
      &.hide-icon i{
        color: #fafafa
      }
    }

    .action-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }

    .log-details {
      font-size: 11px;
      color: #666;

      /deep/ br {
        content: 'a';
        display: block;
        margin-bottom: 15px;
      }

      /deep/ i.float-mt{
        float: left;
        clear: both;
        margin: 10px 0;
        line-height: 1.25;
        letter-spacing: .3px;
      }
    }
  }
  .minimize {
    font-size: 11px;
    color: #666;
    content: "";
    // display: table;
    clear: both;

    .icon-display {
      float: left;
      width: 5%;
      i {
        font-size: 11px;
        color: #666;
      }
      &.hide-icon i{
        color: #fafafa
      }
    }

    .action-display {
      float: left;
      width: 95%;
      p {
        margin: 0;
      }
    }

  }

  .field{
    font-size: 12px;
    padding: 4px 0 4px 10px;

    span{ display: inline-block; }
    .label{
      font-weight: 600;
      margin-right: 10px;
      color: #28b560;
      display: block;
    }
    i{
      margin: 0 5px;
      color: #0D79F2;
    }
    .old{
      color: #d0d0d0;
      &.last{ display:none; }
    }
    .new{
      color: #555;
      font-weight: 600;
    }

    &.no-arrow{
      i{ display: none; }
      .new{ display: block; }
      .old.first{ display: none;}
      .old.last{
        display: block;
        font-size: 12px;
      }
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>

<style lang="scss">
.__service-label{
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
  margin-top: 2px;
  text-transform: capitalize;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/ActionLogs.vue